import React, { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import styles from "./index.module.scss";
import Form, { FormItem } from "../Form";
import Input from "../Input";
import Skeleton from "./Skeleton";
import Link from "next/link";
import CouldntFind from "./CouldntFind";
import CloseSVG from "./close.svg";
import PaywallsForm from "../forms/PaywallsForm";
import { usePaywallsFormSubmit } from "../../../hooks/usePaywallsFormSubmit";
import PaywallsGratitude from "../forms/PaywallsForm/PaywallsGratitude";

const Filter = dynamic(() => import("./Filter"));
const ImageApp = dynamic(() => import("./ImageApp"));

export default function Gallery(props) {
  const router = useRouter();
  const [mobileFilterShown, setMobileFilterShown] = useState();
  const scrollRef = useRef();
  const [showGratitude, setShowGratitude] = useState(false);
  const handleSubmit = usePaywallsFormSubmit(() => setShowGratitude(true));

  const {
    items = [],
    categories = [],
    verticals = [],
    callToActions = [],
    components = [],
    isLoading = false,
    filterParams,
    onChange,
  } = props;

  const filterObj = Object.fromEntries(
    Object.entries(router.query).filter(
      ([key]) => key !== "page" && key !== "q"
    )
  );
  const countFilters = Object.keys(filterObj).length;

  useEffect(() => {
    const obj = router.query;
    for (const key in obj) {
      if (key === "page") {
        scrollRef.current.scrollIntoView();
      }
    }
  }, [props]);

  useEffect(() => {
    if (mobileFilterShown) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [router, mobileFilterShown]);

  return (
    <div className={styles.root} ref={scrollRef}>
      <div className={styles.search}>
        <Form onChange={onChange}>
          <FormItem>
            <Input
              className={styles.searchInput}
              placeholder="Search app"
              name="q"
            />
          </FormItem>
        </Form>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.filterActions}>
          <span onClick={() => setMobileFilterShown(true)}>
            Filters&nbsp;
            {countFilters > 0 && (
              <span className={styles.counter}>{countFilters}</span>
            )}
          </span>
        </div>
        <div className={styles.aside_wrapper}>
          <div
            className={`${styles.filter} ${
              mobileFilterShown && styles.mobileShown
            }`}
          >
            <div className={styles.head}>
              <label>Filter</label>
              <span
                className={styles.closeButton}
                onClick={() => setMobileFilterShown(false)}
              >
                <CloseSVG />
              </span>
            </div>
            <Filter
              categories={categories}
              verticals={verticals}
              callToActions={callToActions}
              components={components}
              onChange={(e) => {
                props?.onChange(e);
              }}
              filterParams={filterParams}
            />
          </div>
          {!showGratitude ? (
            <PaywallsForm submitHandler={handleSubmit} />
          ) : (
            <PaywallsGratitude />
          )}
        </div>
        <div className={styles.data}>
          {items.length > 0 ? (
            <>
              <div className={styles.items}>
                {items.map((item, i) => (
                  <Skeleton key={i} isLoading={isLoading}>
                    <div className={styles.item}>
                      <div className={styles.head}>
                        <div className={styles.icon}>
                          <img
                            width="27.09"
                            height="27.09"
                            src={item.icon_url}
                            loading="lazy"
                            alt="icon"
                          />
                        </div>
                        <div className={styles.label}>
                          <Link href={`/gallery/${item.id}`}>
                            <a>{item.name}</a>
                          </Link>
                        </div>
                      </div>
                      <ImageApp item={item} i={i} />
                    </div>
                  </Skeleton>
                ))}
              </div>
              <div className={styles.pagination}>{props?.pagination}</div>{" "}
            </>
          ) : (
            <CouldntFind />
          )}
        </div>
      </div>
    </div>
  );
}
